/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Visualize_Forest_TitleInputs */

const en_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every focus session is saved. Build habits, see progress.`)
};

const ar_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتم حفظ كل جلسة تركيز. ابنِى عاداتك، وشاهد تقدمك.`)
};

const de_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Fokus-Sitzung wird gespeichert. Gewohnheiten aufbauen, Fortschritte sehen.`)
};

const es_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada sesión de concentración se guarda. Crea hábitos, mira el progreso.`)
};

const fr_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque session de concentration est enregistrée. Construisez des habitudes, voyez les progrès.`)
};

const it_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni sessione di concentrazione viene salvata. Crea abitudini, osserva i progressi.`)
};

const ja_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての集中セッションが保存されます
習慣を作り、成長を実感しましょう`)
};

const ko_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 집중 세션이 저장됩니다. 습관을 형성하고 진행 상황을 확인해 보세요.`)
};

const pt_br_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda sessão de foco é salva. Forme hábitos, veja o progresso.`)
};

const ru_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждый сеанс фокусировки сохраняется. Вырабатывайте привычку, наблюдайте за прогрессом.`)
};

const th_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกการโฟกัสจะถูกบันทึกไว้ สร้างนิสัยดี ๆ แล้วติดตามความก้าวหน้าของคุณ`)
};

const tr_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her odaklanma oturumu kaydedilir. Alışkanlıklar kazan, ilerlemeni takip et.`)
};

const zh_cn_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的每次专注都会在森林留下纪录，你将可以…`)
};

const zh_tw_walkturough_visualize_forest_title = /** @type {(inputs: Walkturough_Visualize_Forest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的每次專注都會在森林留下紀錄，你將可以…`)
};

/**
* | output |
* | --- |
* | "Every focus session is saved. Build habits, see progress." |
*
* @param {Walkturough_Visualize_Forest_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_visualize_forest_title = /** @type {((inputs?: Walkturough_Visualize_Forest_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Visualize_Forest_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_visualize_forest_title(inputs)
	if (locale === "ar") return ar_walkturough_visualize_forest_title(inputs)
	if (locale === "de") return de_walkturough_visualize_forest_title(inputs)
	if (locale === "es") return es_walkturough_visualize_forest_title(inputs)
	if (locale === "fr") return fr_walkturough_visualize_forest_title(inputs)
	if (locale === "it") return it_walkturough_visualize_forest_title(inputs)
	if (locale === "ja") return ja_walkturough_visualize_forest_title(inputs)
	if (locale === "ko") return ko_walkturough_visualize_forest_title(inputs)
	if (locale === "pt_br") return pt_br_walkturough_visualize_forest_title(inputs)
	if (locale === "ru") return ru_walkturough_visualize_forest_title(inputs)
	if (locale === "th") return th_walkturough_visualize_forest_title(inputs)
	if (locale === "tr") return tr_walkturough_visualize_forest_title(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_visualize_forest_title(inputs)
	return zh_tw_walkturough_visualize_forest_title(inputs)
});